import React, { useContext, useState } from 'react'
import { Col } from 'react-bootstrap'
import Card from 'react-bootstrap/Card'
import { Link } from 'react-router-dom'
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

import { defaultToEmptyString, twoDigits } from '../../../assets/ts/formatting/formatting'
import { RoleContext } from '../../../store/role-context-provider'
import CustomTooltip from '../custom-tooltip'
import './charts.css'
import './piecharts.css'

// Function that renders a custom XAxis for the byCategories Chart
const CustomYAxisTick = ({ payload, x, y }: any) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text dx={-10} fill='#666' fontSize='11' textAnchor='start' x={0} y={0}>
        <tspan>
          {payload.value === 0
            ? defaultToEmptyString(payload.value)
            : defaultToEmptyString(twoDigits(payload.value))}
        </tspan>
      </text>
    </g>
  )
}
CustomYAxisTick.displayName = 'CustomYAxis'

const CustomXAxisTick = ({ payload, x, y }: any) => {
  const labels = payload.value.split(' ')
  const labelElements = labels.map((label: string, index: number) => (
    <text
      dy={8}
      fill='#666'
      fontSize='7.5'
      fontWeight={700}
      key={index}
      textAnchor='end'
      transform={'rotate(-40)'}
      x={0}
      y={index * 8}
    >
      {defaultToEmptyString(label)}
    </text>
  ))
  return <g transform={`translate(${x},${y})`}>{labelElements}</g>
}
CustomXAxisTick.displayName = 'CustomXAxis'

const ByStatusChart = (props: any) => {
  const roles = useContext(RoleContext)
  const { formattedData, isDueOut } = props

  return (
    <Col
      className='align-items-stretch w-100-important my-2 d-flex'
      lg={roles.isCSS && !isDueOut ? '6' : '4'}
      md={6}
      sm={12}
    >
      <Card className='w-100'>
        <Card.Body className='d-flex flex-column'>
          <div style={{ alignItems: 'center', display: 'flex', marginTop: 16 }}>
            <p
              style={{
                color: '#355062',
                fontSize: 12,
                marginBottom: 100,
                marginRight: 0,
                padding: 0,
                textWrap: 'nowrap',
                transform: 'rotate(-90deg)',
              }}
            >
              {isDueOut ? 'Due Outs' : 'Inquiries'}
            </p>
            <ResponsiveContainer height={300} width='98%'>
              <BarChart
                aria-label='By Status Chart'
                className='tooltiphidefocus'
                data={formattedData}
                margin={{ bottom: 20, left: 0, right: 5, top: 0 }}
              >
                <CartesianGrid strokeOpacity={0.5} vertical={false} />
                <Bar
                  dataKey='value'
                  isAnimationActive={false}
                  maxBarSize={20}
                  radius={[10, 10, 0, 0]}
                  tabIndex={0}
                  viewBox='0 0 100 100'
                >
                  {formattedData.map((entry) => (
                    <Cell aria-label={entry.name} key={defaultToEmptyString(entry.name)} />
                  ))}
                </Bar>
                <XAxis
                  dataKey='name'
                  interval={0}
                  stroke='#eaf0f4'
                  strokeWidth={2}
                  tick={CustomXAxisTick}
                  tickLine={false}
                />
                <YAxis
                  allowDecimals={false}
                  dataKey='value'
                  height={160}
                  interval='preserveStartEnd'
                  stroke='#eaf0f4'
                  strokeWidth={3}
                  tick={CustomYAxisTick}
                  tickLine={false}
                  width={20}
                />
                <YAxis orientation='right' stroke='#eaf0f4' strokeWidth={3} />
                <Tooltip
                  content={<CustomTooltip />}
                  cursor={{ fill: 'transparent' }}
                  isAnimationActive={false}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <div style={{ fontSize: '12px', margin: '0 auto' }}>
            <p
              style={{
                color: '#355062',
                fontSize: 12,
                padding: 0,
                textWrap: 'nowrap',
              }}
            >
              Status
            </p>
          </div>
        </Card.Body>
      </Card>
    </Col>
  )
}

export default ByStatusChart
